import { Link } from '@remix-run/react'
import { withdrawalLocale, withdrawalText } from './translations'

export function WithdrawalButton({ locale }: { locale: string }) {
	return (
		<Link
			to={`/${locale}/withdrawal`}
			className="app-NavLink inline-block rounded border border-current px-4 py-2 font-semibold"
		>
			{withdrawalText[withdrawalLocale(locale)].start}
		</Link>
	)
}
